<div id="upload-component" [ngStyle]="{'marginTop': isDesktop()  ? '220px' : '40px'}">
    <h1>
        <lucide-angular name="monitor-down" strokeWidth="2" size="44">q</lucide-angular>
        {{ 'nav.upload.title' | translate }}
    </h1>
    <p>{{ 'upload.hook' | translate }}</p>
    @if(isLoading()){

    <div class="uploading-element">
        <ng-lottie [options]="{ path: '/assets/animations/svet-loader.json'}"></ng-lottie>
        @if(uploadProgress() < 100) { <p class="upload-phase-label">Envoi du fichier... {{ uploadProgress() }}%</p>
            <div class="progress-bar">
                <div class="progress" [style.width.%]="uploadProgress()"></div>
            </div>
            } @else {
            <p class="upload-phase-label">Traitement sur le serveur...</p>
            }
    </div>
    } @else {
    <form class="upload" [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
        @if(previewUrl){
        <label class="label" for="title">
            {{ "common.title" | translate }}
            <input type="text" name="title" id="title" formControlName="title">
            @if(uploadForm.controls['title'].invalid && (uploadForm.controls['title'].dirty ||
            uploadForm.controls['title'].touched)){

            <p class="error">
                @if (uploadForm.controls['title'].errors?.['minlength']) {
                @let minLengthRequired = uploadForm.controls['title'].errors?.['minlength']?.requiredLength;
                minimum {{ minLengthRequired }} characters.
                }
                @else if (uploadForm.controls['title'].errors?.['maxlength']) {
                @let maxLengthRequired = uploadForm.controls['title'].errors?.['maxlength']?.requiredLength;
                maximum {{ maxLengthRequired }} characters.
                }
            </p>
            }
        </label>
        }

        @if(previewUrl === null ) {
        <label for="upload" class="input-video" appFileDrop (fileDropped)="onFileDropped($event)">
            <lucide-angular name="plus" size="44" strokeWidth="2" color="#EFF9F5" />
            <input [multiple]="false" type="file" name="upload" id="upload" accept="video/mp4"
                (change)="onFileSelected($event)">
            <p>{{ 'upload.buttons.import' | translate }}</p>
        </label>

        <ul class="requierment-list">
            <li>{{ 'upload.requierment_list.1' | translate }}</li>
            <li>{{ 'upload.requierment_list.2' | translate }}</li>
        </ul>
        <ul class="advice-list">
            <p>{{ 'upload.advice_list.title' | translate }}</p>
            <li>- {{ 'upload.advice_list.1' | translate }}</li>
            <li>- {{ 'upload.advice_list.2' | translate }}</li>
            <li>- {{ 'upload.advice_list.3' | translate }}</li>
            <li>- {{ 'upload.advice_list.4' | translate }}</li>
        </ul>
        }
        @else {
        <div id="upload-player">
            <div class="remove-video" (click)="removeVideo()">
                <lucide-angular name="x" color="#1D1E2D" />
            </div>
            <video #videoPlayer controls>
                <source [attr.src]="previewUrl" [attr.type]="uploadVideoFormat">
            </video>
        </div>

        @if(videoDuration < clientTokenLeft()){ <p>coût {{videoDuration || 0}} tokens</p>
            }
            @else {
            <span>
                <!-- <p class="error">Oups ! il vous manque {{ videoDuration - (clientTokenLeft ?? 0)}} tokens</p> -->
                <p class="error">{{('upload.errors.no_more_tokens' | translate).replace('{missing_tokens}',
                    videoDuration - clientTokenLeft())}}</p>
            </span>
            }
            }
            @if(previewUrl){
            <label class="label" for="context">
                {{ 'common.context' | translate }} :
                <textarea rows="5" type="text" name="context" id="context" formControlName="context"
                    placeholder="Ajoutez un contexte seulement quand des noms ou mots risquent d’être mal interprétés (par ex. si quelqu’un dit “avec Quentin” mais que SVET pourrait comprendre “avec Antin”)."></textarea>
            </label>

            @if(languages.length > 0 && defaultOriginalLanguageId && defaultOutputLanguageId){

            <!-- @if(clientIsSubscribed()) {
        J'ai payé pour un abonnement, je peux choisir plusieurs langues.
            <app-multi-languages-select [languages]="languages"></app-multi-languages-select>
        } @else { -->
            <div id="lang-selection">
                <label class="select-label" for="language-from">{{ "common.from" | translate | titlecase }}
                    <select name="language-from" id="language-from" formControlName="languageFrom">
                        @for (lang of languages; track $index) {
                        <option [ngValue]="lang.id">{{ 'languages.' + lang.name | translate | titlecase }}</option>
                        }
                    </select>
                </label>
                <lucide-icon name="arrowRight"></lucide-icon>

                <label class="select-label" for="language-to">{{ "common.to" | translate | titlecase }}
                    <select name="language-to" id="language-to" formControlName="languageTo">
                        @for (lang of languages; track $index) {
                        <option [ngValue]="lang.id">{{ 'languages.' + lang.name | translate | titlecase }}</option>
                        }
                    </select>
                </label>

            </div>
            <!-- } -->
            }

            @if(clientTokenLeft() < videoDuration ){ <app-button type="discreet" (onClick)="openTokensPackModal()">
                {{ 'nav.plans.buy_more' | translate}}
                </app-button>
                }
                @else {
                <app-button type="submit" class="submit-btn" [disabled]="!uploadForm.valid">
                    <lucide-angular name="languages" color="#92c1b0ff" />{{ 'upload.buttons.translate' |
                    translate }}</app-button>
                }
                @if(uploadError()) {
                <p class="error">{{ uploadError() }}</p>
                }
                }
    </form>
    }
</div>